import React, {useEffect, useState} from "react";
import ModalPopUp from '../../../module/modalPopUp';
import {StepComponent} from '../../../module/step_component';
import {updateHeader, updateUrl} from '../../../store/actions/main';
import {updateEditStahltreppe} from '../../../store/actions/stahltreppen';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import {stahltreppe_auswahl} from '../../../../assets/images/data';
import ImageSlider from '../../../module/imageSlider';
import {ProductInfo} from '../../../module/productInfo';

const Index = (props) => {

   const [showModalStepper, setShowModalStepper] = useState(false);
   const [showModalInfo, setShowModalInfo] = useState(false);
   const [showModalImages, setModalImages] = useState(false);

   const closeModal = () => setShowModalStepper(false);
   const closeModalInfo = () => setShowModalInfo(false);
   const closeModalImages = () => setModalImages(false);

   useEffect(() => {
        updateItems();
   })

   const updateItems = () => {
      props.updateHeader('Stahltreppe');
      updateEdit();

   }

   const showStepper = ev => {
      let titel = ev.currentTarget.getAttribute('titel');
      props.updateUrl(titel);
      setShowModalStepper(true);
   }

   const showInfo = () => setShowModalInfo(true);
   const showImages = () => setModalImages(true);

   const updateEdit = () => {
      let button = document.querySelector('.product_main_wrapper .button');
         if (props.isEdit) {
            button.click();
            props.updateEdit();
         }
   }


      return (
         <div className="product_main_wrapper">
         <div className='product_wrapper'>
            <div className='inner-modell-wrapper-zaune'>
               <ImageSlider
                  showImages={showImages}
                  imageposter={stahltreppe_auswahl.portfolio}
               />
               <div className="button-wrapper">
                     <Button onClick={showStepper} titel="Stahltreppe" className='button'>Konfigurator starten</Button>
                     <Button onClick={showInfo} className='button info'>Mehr Informationen</Button>
               </div>
            </div>
         </div>
         <ModalPopUp
            title="Stahltreppen-Bilder"
            class='modell'
            component={<ImageSlider showModalImages={showModalImages} imageposter={stahltreppe_auswahl.portfolio} />}
            showModal={showModalImages}
            hideModal={closeModalImages}
         />
         <ModalPopUp
            title="Stahltreppe"
            class='modell'
            component={<StepComponent />}
            showModal={showModalStepper}
            hideModal={closeModal}
         />
         <ModalPopUp
               title="Produktbeschreibung - Stahltreppe"
               class='modell'
               component={<ProductInfo
                           type=""
                           desc={stahltreppe_auswahl.desc}
                           desc_items={stahltreppe_auswahl.content}
                           price={`Ab ${props.price.toFixed(2)}€`}
                           />}
               showModal={showModalInfo}
               hideModal={closeModalInfo}
            />
    </div>
       )
}

const mapStateToProps = state => {
   return {
      isEdit: state.stahltreppenReducer.data.isEdit,
      price: state.stahltreppenReducer.data.modell[0].price
   }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        updateEdit: () => dispatch(updateEditStahltreppe())
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);

